<template>
  <v-app-bar
    color="primary"
    class="white--text"
  >
   <!-- elevate-on-scroll
    scroll-target="#scrolling-techniques-7"-->
    <v-app-bar-nav-icon @click="toHome" v-if="back">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="white" v-on="on">arrow_back</v-icon>
        </template>
        <span>Regresar al Inicio</span>
      </v-tooltip>
    </v-app-bar-nav-icon>

    <v-toolbar-title><b>{{title}}</b></v-toolbar-title>
    <div class="flex-grow-1"></div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="signUp">
          <v-icon color="white">exit_to_app</v-icon>
        </v-btn>
      </template>
      <span>Cerrar sesión</span>
    </v-tooltip>
  </v-app-bar>
</template>


<script>

import router from "@/router.js";

export default {
  name: 'DashboardBar',
  props:{
    title:{
      type: String,
      required: true,
    },
    back:{
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data(){
    return {
    }
  },
  methods:{
    toHome(){
      this.$store.dispatch('REDIRECT_LOGIN', true)
    },
    signUp(){
      this.$store.dispatch('LOGOUT')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>